import React from "react";
import { getSellPayment } from "@actions/sellOrderInfo";
import { connect } from "react-redux";
import styled from "@emotion/styled";
import { format, parseISO } from "date-fns";
import { currencyFormatter } from "@utils";

const MainGridLarge = styled.div`
  display: grid;
  grid-template-columns: 114px 107px 1fr 1fr auto;
  grid-row-gap: 20px;
  grid-column-gap: 10px;
  margin-bottom: 16px;
  @media (max-width: 530px) {
    grid-template-columns: 98px 90px 60px 1fr auto;
  }
  @media (max-width: 455px) {
    grid-template-columns: 92px 76px 62px 1fr auto;
  }
  @media (max-width: 425px) {
    display: none;
  }
`;

const GridItem = styled.div`
  font-size: 14px;
  color: #1f2021;

  @media (max-width: 530px) {
    font-size: 13px;
  }
  @media (max-width: 455px) {
    font-size: 12px;
  }
  @media (max-width: 425px) {
    font-size: 13px;
  }
`;

const GridItemHeader = styled.div`
  font-size: 13px;
  font-weight: bold;
  color: #777984;
`;

const GridItemLast = styled(GridItem)`
  cursor: pointer;
  font-weight: bold;
  color: #12b2ea;
`;

const MobileContainer = styled.div`
  @media (min-width: 426px) {
    display: none;
  }
  display: grid;
  grid-template-columns: 1fr auto;
  padding-bottom: 10px;
  margin-bottom: 10px;
  grid-row-gap: 10px;
`;

const PaymentDetailsRow = ({
  payment,
  getSellPayment,
  setCardSelected,
  setLoader
}) => {
  const openPaymentDetailsModalLocal = async id => {
    setLoader(true);
    await getSellPayment(id);
    setCardSelected(true);
    setLoader(false);
  };
  return (
    <>
      <MainGridLarge>
        <GridItem>{format(parseISO(payment.date), "MMM d, yyyy")}</GridItem>
        <GridItem>{payment.id}</GridItem>
        <GridItem>{payment.status}</GridItem>
        <GridItem>{currencyFormatter(payment.amount)}</GridItem>
        <GridItemLast onClick={() => openPaymentDetailsModalLocal(payment.id)}>
          Details
        </GridItemLast>
      </MainGridLarge>
      <MobileContainer>
        <GridItemHeader>Payment Date</GridItemHeader>
        <GridItem>{format(parseISO(payment.date), "MMM d, yyyy")}</GridItem>
        <GridItemHeader>Payment ID</GridItemHeader>
        <GridItem>{payment.id}</GridItem>
        <GridItemHeader>Status</GridItemHeader>
        <GridItem>{payment.status}</GridItem>
        <GridItemHeader>Amount</GridItemHeader>
        <GridItem>{currencyFormatter(payment.amount)}</GridItem>
        <GridItemLast onClick={() => openPaymentDetailsModalLocal(payment.id)}>
          Details
        </GridItemLast>
      </MobileContainer>
    </>
  );
};

export default connect(null, dispatch => ({
  getSellPayment: id => dispatch(getSellPayment(id))
}))(PaymentDetailsRow);
